var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.3 84.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b952;}.cls-2,.cls-3,.cls-4{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-2,.cls-4{stroke-width:5px;}.cls-3,.cls-4{stroke-linecap:round;}.cls-3{stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clear-dayAsset 135colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 42.48,
    cy: 42.15,
    r: 18.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.19,23.2A18.84,18.84,0,1,0,61,42,18.86,18.86,0,0,0,42.19,23.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.15,
    y1: 14.23,
    x2: 42.15,
    y2: 6.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.15,
    y1: 78.23,
    x2: 42.15,
    y2: 70.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.23,
    y1: 42.15,
    x2: 6.07,
    y2: 42.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 78.23,
    y1: 42.15,
    x2: 70.07,
    y2: 42.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.41,
    y1: 22.41,
    x2: 16.64,
    y2: 16.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.66,
    y1: 67.66,
    x2: 61.89,
    y2: 61.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.41,
    y1: 61.89,
    x2: 16.64,
    y2: 67.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.66,
    y1: 16.64,
    x2: 61.89,
    y2: 22.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 54.63,
    y1: 11.47,
    x2: 58.28,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.02,
    y1: 81.8,
    x2: 29.67,
    y2: 72.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11.47,
    y1: 29.67,
    x2: 2.5,
    y2: 26.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 81.8,
    y1: 58.28,
    x2: 72.83,
    y2: 54.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29.28,
    y1: 11.63,
    x2: 25.52,
    y2: 2.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 58.78,
    y1: 81.59,
    x2: 55.02,
    y2: 72.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11.63,
    y1: 55.02,
    x2: 2.71,
    y2: 58.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 81.59,
    y1: 25.52,
    x2: 72.67,
    y2: 29.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearDay);
export default __webpack_public_path__ + "static/media/clear-day.0ae928911d7143fe5c97e319ad437e49.svg";
export { ForwardRef as ReactComponent };